
import Productpage from './productpage.vue'
import Productdetail from './productdetail.vue'

export default {
	Productpage,
  Productdetail
}



// WEBPACK FOOTER //
// ./src/views/detail/index.js